import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { InitiativeJiraIssuesName } from '../name';
import { getInitiativesJiraIssueSlice } from '../@async/get';

type UpdateJiraIssueRequest = {
    issueKey: string;
}

export const initiativesJiraIssueUpdateSlice = createUpdateSyncSlice({
	name: InitiativeJiraIssuesName,
	state: getInitiativesJiraIssueSlice.asyncState,
	transform: (action: UpdateJiraIssueRequest, state = []) => {
        const updatedState = state.map((jiraIssue) => {
            if (jiraIssue.issueKey === action.issueKey) {
                return {
                    ...jiraIssue,
                    isSynced: !jiraIssue.isSynced
                }
            }

            return {
                ...jiraIssue,
                isSynced: false
            };
        })

		return updatedState;
	}
});
